import { DataTableActionPayload } from '@/utils/types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';


const initialState = {

};

const dataTableStateSlice = createSlice({
    name: 'dataTableStateSlice',
    initialState,
    reducers: {
        setDataTableState: (state, { payload }: PayloadAction<DataTableActionPayload>) => {
            const { key, page, filters } = payload
            return { ...state, [key]: { page, filters } };
        },
        resetData: (state) => {
            return {};
        },
    },
});
export const { resetData, setDataTableState } = dataTableStateSlice.actions;
export default dataTableStateSlice;
